import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/deals`;

// ✅ Auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

// ✅ Toast error handler
const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

// ✅ Export all deals - PDF
export const exportDealsPDF = async (): Promise<Blob> => {
  try {
    const res = await axios.get(`${BASE_URL}/export/pdf`, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to export Deals PDF");
    throw error;
  }
};

// ✅ Export all deals - Excel
export const exportDealsExcel = async (): Promise<Blob> => {
  try {
    const res = await axios.get(`${BASE_URL}/export/excel`, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to export Deals Excel");
    throw error;
  }
};

// ✅ Export selected deals - PDF
export const exportSelectedDealsPDF = async (
  dealIds: string[]
): Promise<Blob> => {
  try {
    const params = new URLSearchParams();
    dealIds.forEach((id) => params.append("deal_ids", id));

    const res = await axios.get(
      `${BASE_URL}/export/pdf/multiple?${params.toString()}`,
      {
        responseType: "blob",
        headers: getAuthHeaders(),
      }
    );
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to export selected Deals PDF");
    throw error;
  }
};

// ✅ Export selected deals - Excel
export const exportSelectedDealsExcel = async (
  dealIds: string[]
): Promise<Blob> => {
  try {
    const params = new URLSearchParams();
    dealIds.forEach((id) => params.append("deal_ids", id));

    const res = await axios.get(
      `${BASE_URL}/export/excel/multiple?${params.toString()}`,
      {
        responseType: "blob",
        headers: getAuthHeaders(),
      }
    );
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to export selected Deals Excel");
    throw error;
  }
};
